import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { setToken } from "../lib/tokenStore";
import { useAuth } from "../lib/auth";
import { log } from "../lib/logger";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data?.token) setToken(data.token);
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        nav("/portal");
      } catch (err) {
        log.error("OAuth session exchange failed", err);
        nav("/login");
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-white/60 text-sm">
      Signing you in…
    </div>
  );
}
